import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import DialogProvider from 'src/components/dialogs/DialogProvider';
import djangoContextHelper from './django-context-helper';
import setUpTranslation from './setUpTranslation';
import { TranslationKeys } from 'src/interfaces/translation';

import 'styles/_app.scss';

const djangoContext = djangoContextHelper();
console.log('djangoContext', djangoContext);

/**
 * init necessary settings e.g. i18n and render the page component to body in html
 * @param PageComponent component that render the page contents
 */
export const renderPage = async <T,>(
  PageComponent: (props: T) => JSX.Element,
  translationNameSpaces?: TranslationKeys[]
) => {
  await setUpTranslation(translationNameSpaces);
  const contextData = djangoContextHelper()?.data || {};
  ReactDOM.createRoot(document.querySelector('body') as HTMLElement).render(
    <HelmetProvider>
      <React.StrictMode>
        <Helmet>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
          <link
            href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap"
            rel="stylesheet"
          />
        </Helmet>
        {/* <!-- Google Tag Manager (noscript) --> */}
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-TSVHR9K6"
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>
        {/* <!-- End Google Tag Manager (noscript) --> */}
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        <PageComponent {...(contextData as any)} />
        <DialogProvider />
      </React.StrictMode>
    </HelmetProvider>
  );
};

export default {
  renderPage,
};
